import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { Subscription } from 'rxjs';

interface AbstractControlWithListener extends AbstractControl {
  _isEqualChangeListener?: Subscription;
}

export function isEqual(
  controlName: string,
  controlNameToCompare: string
): ValidatorFn {
  return (control: AbstractControlWithListener): ValidationErrors | null => {
    const form = control.parent;
    const linkedControl = form?.get(controlName);
    const controlToCompare = form?.get(controlNameToCompare);

    // Revalidate the dependent control when the linked control's value changes
    if (!control._isEqualChangeListener) {
      control._isEqualChangeListener = linkedControl?.valueChanges.subscribe(
        () => {
          control.updateValueAndValidity();
        }
      );
    }

    if (
      linkedControl &&
      controlToCompare &&
      linkedControl.value === controlToCompare.value
    ) {
      control?.setErrors(null);
      return null;
    }
    control?.setErrors({ notEqual: true });
    return { notEqual: true };
  };
}
